export const columns = [
    {
        title:'日期',
        dataIndex:"createTime",
        key:"createTime",
    },
    {
        title:'姓名',
        dataIndex:"name",
        key:"name",
    },
    {
        title:'手机号',
        dataIndex:"phone",
        key:"phone",
    },
    {
        title:'上课方式',
        dataIndex:"attendClassWay",
        key:"attendClassWay",
        slots:'attendClassWay'
    },
    {
        title:'出发地',
        dataIndex:"startingPoint",
        key:"startingPoint",
    },
    {
        title:'目的地',
        dataIndex:"destination",
        key:"destination",
    },
    {
        title:'交通方式',
        dataIndex:"transport",
        key:"transport",
        slots:"transport",
    },
    // {
    //     title:'是否用餐',
    //     dataIndex:"dinner",
    //     key:"dinner",
    //     slots:"dinner",
    // },
    {
        title:'预估排碳量',
        dataIndex:"carbonEmission",
        key:"carbonEmission",
    },
]